export const FORM_LOGIN = {
  email: "",
  password: "",
};
